import { render } from "./LogReport.vue?vue&type=template&id=31c94c9e&scoped=true"
import script from "./LogReport.vue?vue&type=script&lang=ts"
export * from "./LogReport.vue?vue&type=script&lang=ts"

import "./LogReport.vue?vue&type=style&index=0&id=31c94c9e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31c94c9e"

export default script